const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const fallbackOrigin =
  typeof window !== "undefined" ? window.location.origin : "";
const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();
const isLocalDev =
  fallbackOrigin.includes("localhost") || fallbackOrigin.includes("127.0.0.1");

// Use a relative /api path in production so requests stay on the active host.
const baseUrl = isLocalDev && configuredBackendUrl
  ? configuredBackendUrl
  : fallbackOrigin || configuredBackendUrl || "";

export const BACKEND_URL = trimTrailingSlash(baseUrl);
export const API_URL = isLocalDev && BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
